import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import './style.css';
import { Breadcrumb } from '../components/Breadcrumb';
import { PageTitle } from '../components/PageTitle';

const PAGETITLE_JP = '企業理念';
const PAGETITLE_EN = 'Philosophy';



const PhilosophyCardTitle = styled.div.attrs({className: 'philosophy-card-title'})`
  margin-bottom: 30px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;





export const NotFoundPage: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', padding: '100px 20px' }}>
      <h1 style={{ fontSize: '72px', marginBottom: '20px', color: '#333' }}>404</h1>
      <p style={{ fontSize: '18px', marginBottom: '40px', color: '#666' }}>
        お探しのページは見つからないか、移動した可能性があります。
      </p>
      <a 
        href="/" 
        style={{ 
          display: 'inline-block', 
          padding: '12px 24px', 
          backgroundColor: '#0F3F8E', 
          color: '#fff', 
          textDecoration: 'none',
          borderRadius: '50vh'
        }}
      >
        トップページに戻る
      </a>
    </div>
  );
};

export default NotFoundPage;
